/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { WrapperSeamless } from "layout-components";
import Table from "components/tables/table";
import { useGetList } from "hooks";
import * as Api from "service";
import { useTranslation } from "localization/translation";
import useStore from "context";

export default function Contact() {
  const [items, total, refresh, setItems] = useGetList(Api.contact.getAll);
  const translation = useTranslation();

  const { setMessagesUnseenCount, language } = useStore();

  const rows = items?.map((item) => (
    <>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.name}</div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.email} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.phone_number} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.text} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item[`plan_name_${language}`]} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.plan_type} </div>
      </td>
      <td className="text-left px-4">
        <div className="font-size-sm">{item.establishment} </div>
      </td>
    </>
  ));

  useEffect(() => {
    if (items?.length) {
      const unseenMessages = items?.filter((item) => !item.seen_by_admin);
      const unseenMessagesIds = unseenMessages?.map((item) => item.id);

      if (unseenMessagesIds?.length) {
        Api.main
          .updateMessagesUnseenCount({ ids: unseenMessagesIds })
          .then(() => {
            Api.main
              .getUsersUnseenCount()
              .then((res) => setMessagesUnseenCount(res?.count ?? 0));
          });
      }
    }
  }, [items]);

  return (
    <WrapperSeamless>
      <Table
        fields={
          <>
            <th className="text-left px-4">
              <span className="mr-3">{translation.company_name}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.email}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.phone}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.text}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.plan_name}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.plan_type}</span>
            </th>
            <th className="text-left px-4">
              <span className="mr-3">{translation.type_of_establishment}</span>
            </th>
          </>
        }
        noDrag
        title={translation.contact}
        items={items}
        setItems={setItems}
        total={total}
        rows={rows}
        actions={false}
      />
    </WrapperSeamless>
  );
}
